export function handleOriginalNews (container, link) {
  const origin_news_p = container.querySelector('.original-news')
  origin_news_p?.remove()
}